import MuiAppBar from '@mui/material/AppBar';
import Grid from '@mui/material/GridLegacy';
import Toolbar from '@mui/material/Toolbar';
import { useContext } from 'react';

import { CustomizationInfo } from './CustomizationInfo';
import { MenuBarV2 } from './menu-bar-v2/MenuBarV2';
import { NavigationMenu, SideDrawerNavigation } from './NavigationMenu';
import { ApplicationContext } from '../../../../shared/source/context/context';
import { getTimeDeltaInDays } from '../../../../shared/source/date/date';
import { companyOnboardingRoutePath } from '../../company-onboarding/route-config';
import { CompanyLogo } from '../../design/components/CompanyLogo';
import { TrialInformation, trialPeriodDays } from '../../purchase/TrialInformation';
import { route } from '../pages/onboarding/constants';

import type { FunctionComponent } from 'react';

const disableAppBarRoutes = [route.patterns.onboarding, companyOnboardingRoutePath];

export const AppBar: FunctionComponent = () => {
    const {
        applicationState: { customization, featureFlagService, location },
    } = useContext(ApplicationContext);
    const { pathname } = location;

    if (disableAppBarRoutes.includes(pathname)) {
        return null;
    }

    const tenantCreatedAt = customization.get('tenantCreatedAt');
    const daysRemaining = tenantCreatedAt.mapOr(0, (createdAt) => {
        return Math.max(0, trialPeriodDays - getTimeDeltaInDays(new Date(), createdAt));
    });
    const newMenuBar = featureFlagService.isFeatureFlagEnabled('new-menu-bar');

    return (
        <MuiAppBar
            component="header"
            elevation={0}
            position="sticky"
            sx={{
                backgroundColor: 'background.default',
            }}
        >
            {customization
                .get('tenantMode')
                .mapOr(null, (mode) => (mode === 'trial' ? <TrialInformation daysRemaining={daysRemaining} /> : null))}
            <CustomizationInfo />
            {newMenuBar ? (
                <MenuBarV2 />
            ) : (
                <Toolbar variant="dense">
                    <Grid alignItems="center" container={true} flexWrap="nowrap" gap={2}>
                        <Grid component={SideDrawerNavigation} flex={0} />
                        <Grid component={CompanyLogo} flex={0} />
                        <Grid component={NavigationMenu} flex={1} />
                    </Grid>
                </Toolbar>
            )}
        </MuiAppBar>
    );
};
